import companyMiddleware from './company/middleware'

export default [companyMiddleware]
